import { plural } from '../../../utils/counts';

/** "1 open task", "2 open tasks". Words, not a bare number, wherever tasks are counted. */
export const openTasksLabel = (count: number): string => plural(count, 'open task', 'open tasks');
